import { render, staticRenderFns } from "./booking.vue?vue&type=template&id=08baf6e6&scoped=true&"
import script from "./booking.ts?vue&type=script&lang=ts&"
export * from "./booking.ts?vue&type=script&lang=ts&"
import style0 from "./booking.scss?vue&type=style&index=0&id=08baf6e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08baf6e6",
  null
  
)

export default component.exports